module.exports = __webpack_public_path__ + "img/live-person-dark.ff8db93e.svg";